<div class="flex items-center">
    <div class="flex flex-col">
        <div class="mr-4 text-lg font-medium tracking-tight leading-6 truncate">
            {{headerTitle!=undefined?headerTitle:('SystemAdmin.Components.ItemPropertyContainer.Header.Title'|translate)}}
        </div>
        <div class="text-secondary font-normal" *ngIf="description">{{description}}</div>
    </div>
    <div class="ml-auto -mt-2 -mr-2">
        <ng-content select="[headerActions]"></ng-content>
        <!-- <button
                    mat-icon-button
                    [matMenuTriggerFor]="budgetMenu">
                    <mat-icon
                        class="icon-size-5"
                        [svgIcon]="'heroicons_solid:dots-vertical'"></mat-icon>
                </button> 
        <mat-menu #budgetMenu="matMenu">
                    <button mat-menu-item>Expenses breakdown</button>
                    <button mat-menu-item>Savings breakdown</button>
                    <button mat-menu-item>Bills breakdown</button>
                    <mat-divider class="my-2"></mat-divider>
                    <button mat-menu-item>
                        <span class="flex items-center">
                            <mat-icon
                                class="icon-size-5 mr-3"
                                [svgIcon]="'heroicons_solid:printer'"></mat-icon>
                            <span>Print budget summary</span>
                        </span>
                    </button>
                    <button mat-menu-item>
                        <span class="flex items-center">
                            <mat-icon
                                class="icon-size-5 mr-3"
                                [svgIcon]="'heroicons_solid:mail'"></mat-icon>
                            <span>Email budget summary</span>
                        </span>
                    </button>
                </mat-menu> -->
    </div>
</div>
<!-- <div class="mt-6">
            Last month; you had <strong>223</strong> expense transactions, <strong>12</strong> savings entries and <strong>4</strong> bills.
        </div> -->

<div class="my-4 space-y-4">
    <ng-content></ng-content>
</div>

<!-- <div class="flex items-center mt-auto">
            <button
                class="mt-2"
                mat-stroked-button>
                Download Summary
            </button>
        </div> -->